import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import modular components
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFloatingButton from './components/WhatsAppFloatingButton';
import ScrollToTop from './utils/ScrollToTop';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import AdminPage from './pages/AdminPage';
import GSAPTest from './components/GSAPTest';
import { initializeScrollAnimations } from './utils/animations';

function App() {
  useEffect(() => {
    // Initialize scroll animations when app loads
    const timer = setTimeout(() => {
      try {
        console.log('App: Initializing global scroll animations');
        initializeScrollAnimations();
      } catch (error) {
        console.log('Failed to initialize scroll animations:', error);
      }
    }, 1000); // Small delay to ensure all components are mounted

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <TopBar />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Footer />
        <WhatsAppFloatingButton />
        <GSAPTest />
      </div>
    </Router>
  );
}

export default App;
